import { IUser } from 'bets.oddprovider.lib.common.ts/models'
import { ApiClientUtils } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { useSnackbar } from 'notistack'
import * as React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { DEFAULTGAP, RoutesNames } from '../../globals'
import { toggleLoading } from '../../redux/reducers/loadingBar.slice'
import { IUsersState, usersStateLoadFromApi } from '../../redux/reducers/users.slice'
import { RootState } from '../../redux/store'
import { HeaderComponent } from '../common/header'
import { SearchInputComponent } from '../common/searchInput'
// import { TableComponent } from '../common/table'
// import { StyledListItemText, StyledTableCell, TableComponentClickRowProps, TableComponentSetCurrPageProps } from '../common/table/common'
import { StyledListItemText, StyledTableCell, TableComponent, TableComponentSetCurrPageProps } from 'fwork.react.apptemplate'

export const UsersComponent = () => {
  const tableComponentSetCurrPageRef = React.useRef<TableComponentSetCurrPageProps>(() => { });
  const tableComponentSetCurrPage = tableComponentSetCurrPageRef.current

  const usersState: IUsersState = useSelector((state: RootState) => state.usersState)
  const users = [...usersState.payload || []]
  const navigate = useNavigate()
  const dispatch = useDispatch<any>()
  const { enqueueSnackbar } = useSnackbar()
  const [searchText, setSearchText] = useState<string | undefined>()

  const loadUsers = async () => {
    dispatch(toggleLoading())
    const where: FilterQuery<IUser> | undefined = searchText ? {
      $or: [{
        name: { $regex: searchText, $options: 'i' }
      }, {
        login: { $regex: searchText, $options: 'i' }
      },]
    } : undefined

    const response = await dispatch(usersStateLoadFromApi({
      where,
      onFinally: () => {
        dispatch(toggleLoading())

        if (tableComponentSetCurrPage)
          tableComponentSetCurrPage({
            page: 0
          })
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))

    if (!response.payload?.data?.payload?.length) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum registro encontrado'), { variant: 'warning' })
    }
  }

  return <>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      paddingBottom: DEFAULTGAP
    }}>
      <HeaderComponent
        props={{
          style: {
            paddingInline: DEFAULTGAP
          }
        }}
        title='Usuários'
        onRefreshClick={loadUsers}
        onAddClick={() => navigate(RoutesNames.user)}
      />

      <SearchInputComponent
        style={{
          marginInline: DEFAULTGAP,
          maxWidth: 500
        }}
        label='Pesquisar nome ou login'
        onChange={e => setSearchText(e.target.value)}
        onKeyUp={e => { if (e.key === "Enter") loadUsers() }}
        onIconClick={loadUsers}
      />
      <TableComponent
        wrapperProps={{ style: { padding: DEFAULTGAP, maxWidth: 'calc(100% - 10px)' } }}
        setCurrPageRef={tableComponentSetCurrPageRef}
        bodyList={users}
        bodyRowBuilder={(user: IUser) => {
          return <StyledTableCell>
            <StyledListItemText
              primary={user.name}
            />
          </StyledTableCell>
        }}
        rowProps={{
          onClickGetItem: (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>, item: IUser) => {
            navigate(RoutesNames.user.replace(':id', item?.id.toString()))
          }
        }}
      />
    </div>
  </>
}